<script>
import { layoutComputed } from "@/state/helpers";

import AppShell from "@/components/AppShell";
import Horizontal from "./horizontal";
import Detached from "./detached";
import TwoColumn from "./two-column";

/**
 * Main layout.
 * Por defecto (layoutType "vertical") usa AppShell: riel lateral + barra superior.
 * Los layouts horizontal / detached / two-column se conservan tal cual.
 * API estable: las vistas usan <Layout>…</Layout> con un slot.
 */
export default {
  components: {
    AppShell,
    Horizontal,
    Detached,
    TwoColumn,
  },
  data() {
    return {};
  },
  computed: {
    ...layoutComputed,
    useShell() {
      return ["horizontal", "detached", "two-column"].indexOf(this.layoutType) === -1;
    },
  },
};
</script>

<template>
  <div>
    <AppShell v-if="useShell">
      <slot />
    </AppShell>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
      <slot />
    </Horizontal>

    <Detached v-if="layoutType === 'detached'" :layout="layoutType">
      <slot />
    </Detached>

    <TwoColumn v-if="layoutType === 'two-column'" :layout="layoutType">
      <slot />
    </TwoColumn>
  </div>
</template>
